import React from 'react';
import queryString from 'query-string';
import { Button, Form, Progress, Alert } from 'reactstrap';
import { CSSTransition } from 'react-transition-group';

import { WithLocalize } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';
import { checkDeviceIOS } from '../../utils'

/**
 * Login Form Container
 *
 * @class LoginForm
 * @extends {React.Component}
 */
class LoginForm extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.parameters = queryString.parse(props.location.search);
    this.parameters.idp = 'ant';
    this.ref = React.createRef();
    this.state = {
      onLogin: false,
      showForm: false,
      error: {
        open: false,
        message: ''
      },
      username: '',
      password: ''
    };
  }

  componentDidMount() {

    this.setState({ showForm: true });
  }

  onError(error) {
    this.setState({
      error: {
        open: true,
        message: error.message
      }
    });
  }

  async onSubmit(ev) {
    ev.preventDefault();

    this.setState({
      onLogin: true,
      error: {
        open: false,
        message: ''
      }
    });



    this.props.api.userPassLogin(
      {
        username: this.usernameInput.value,
        password: this.passwordInput.value,
      }, this.parameters

    )
      .then((response) => {
        this.setState({ onLogin: false });
        window.location = this.parameters.redirect_uri + '?' + queryString.stringify(response);
      })
      .catch(error => {
        const translate = this.props.translate(error.errorCode);

        let message = 'Occurrió un error.';

        if (translate) {
          message = translate;
        } else if (error.details) {
          message = error.details;
        }

        this.setState({ onLogin: false, error: { open: true, message: message } });
      });
  }

  render() {
    const { translate } = this.props;

    return (
      <CSSTransition
        in={this.state.showForm}
        timeout={300}
        classNames="formshow"
        nodeRef={this.ref}
        unmountOnExit
      >
          <Form onSubmit={event => this.onSubmit(event)} className='form-ant'>
            <div ref={this.ref}>
              <p className="description">Iniciá sesión para disfrutar todo el contenido exclusivo cuando quieras.Debés
              utilizar tu usuario y contraseña de Antina.</p>
            <input
              className="form-control-ant user-input-ant"
              disabled={this.state.onLogin}
              placeholder={translate('E-mail Registrado')}
              ref={(ref) => {
                this.usernameInput = ref;
              }
              }
              required={true}
              tabIndex={1}
              type="email"
              autoCorrect="off"
              autoCapitalize="none"
              name="username"
            />
            <input
              className="form-control-ant user-input-ant"
              required={true}
              disabled={this.state.onLogin}
              placeholder={translate('Contraseña')}
              ref={(ref) => {
                this.passwordInput = ref;
              }
              }
              tabIndex={1}
              type="password"
              autoCorrect="off"
              autoCapitalize="none"
              name="password"
            />
            <div className="buttons">
              {!this.state.onLogin ?
                <Button
                  block={!this.parameters.failureRedirect}
                  tabIndex={1}
                  className="enter-ant"
                  type="submit"
                  name="submit"
                  disabled={!this.props.turnstileSuccess}
                >
                  {translate('Ingresar')}
                </Button> :
                <Progress animated color="danger" value={100} />}
            </div>
            <div className="messages-container">
              <Alert color="danger" id="error-message" isOpen={this.state.error.open} toggle={() => this.setState({ error: { open: false } })}>
                {this.state.error.message}
              </Alert>
            </div>
            <ul>
              <p className="actions">Si aún no sos cliente de Antina <a
                href="https://antina.com.ar/contratar-online.aspx" target="_blank" rel="noopener noreferrer">[Ingresá aqui]</a></p>
              {checkDeviceIOS() ? '' : <p className="actions">Si aún no estás registrado <a href="https://antina.com.ar/atencion-clientes/registro.aspx" target="_blank" rel="noopener noreferrer">[Ingresá
                aqui]</a></p>}
              <p className="actions">¿Olvidaste tu contraseña? <a href="https://antina.com.ar/atencion-clientes/recuperar-contrasena.aspx" target="_blank" rel="noopener noreferrer">[Ingresá
                aqui]</a></p>
            </ul>
            </div>

          </Form>
      </CSSTransition>
    );
  }
}

export default WithCaptcha(WithLocalize(LoginForm));
